import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, UncontrolledTooltip, Table, Spinner, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import { FaSort } from 'react-icons/fa'
import utilities from '../util/utilities';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from "moment";

//Warm Gray - #5C5C5C
//Orange - #F26230 #FFFFFF
//Light Gray - #DDDDDD
//Almost Black - #373737
//backgroundColor: '#F26230', color: '#FFFFFF'

export class LeaseDetailsContacts extends Component {
    static displayName = LeaseDetailsContacts.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            clientOptions: [],
            client: null,
            clientText: null,
            search: null,
            contacts: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100000,
            numberOfPages: 0,
            testType: 'Selection',
            testLevel: 'MA',
            leaseId: id,
            typeOptions: [{ label: "Branch/Store Manager", value: "Branch/Store Manager" },
            { label: "Landlord", value: "Landlord" },
            { label: "Property Manager", value: "Property Manager" },
            { label: "Landlord's Leasing Agent", value: "Landlord's Leasing Agent" },
            { label: "Tenant's Real Estate Broker", value: "Tenant's Real Estate Broker" },
            { label: "Architect", value: "Architect" },
            { label: "General Contractor", value: "General Contractor" },
            { label: "Other", value: "Other" }],
            bestOptions: [{ label: "Work", value: "1" },
            { label: "Cell", value: "2" },
            { label: "Home", value: "3" },
                { label: "Fax", value: "4" }],
            sstateOptions: [{ label: "AL", value: "AL" }, { label: "AK", value: "AK" }, { label: "AZ", value: "AZ" }, { label: "AR", value: "AR" }, { label: "CA", value: "CA" }, { label: "CO", value: "CO" }, { label: "CT", value: "CT" }, { label: "DE", value: "DE" }, { label: "DC", value: "DC" }, { label: "FL", value: "FL" }, { label: "GA", value: "GA" }, { label: "HI", value: "HI" }, { label: "ID", value: "ID" }, { label: "IL", value: "IL" }, { label: "IN", value: "IN" }, { label: "IA", value: "IA" }, { label: "KS", value: "KS" }, { label: "KY", value: "KY" }, { label: "LA", value: "LA" }, { label: "ME", value: "ME" }, { label: "MD", value: "MD" }, { label: "MA", value: "MA" }, { label: "MI", value: "MI" }, { label: "MN", value: "MN" }, { label: "MS", value: "MS" }, { label: "MO", value: "MO" }, { label: "MT", value: "MT" }, { label: "NE", value: "NE" }, { label: "NV", value: "NV" }, { label: "NH", value: "NH" }, { label: "NJ", value: "NJ" }, { label: "NM", value: "NM" }, { label: "NY", value: "NY" }, { label: "NC", value: "NC" }, { label: "ND", value: "ND" }, { label: "OH", value: "OH" }, { label: "OK", value: "OK" }, { label: "OR", value: "OR" }, { label: "PA", value: "PA" }, { label: "RI", value: "RI" }, { label: "SC", value: "SC" }, { label: "SD", value: "SD" }, { label: "TN", value: "TN" }, { label: "TX", value: "TX" }, { label: "UT", value: "UT" }, { label: "VT", value: "VT" }, { label: "VA", value: "VA" }, { label: "WA", value: "WA" }, { label: "WV", value: "WV" }, { label: "WI", value: "WI" }, { label: "WY", value: "WY" }],
            tn_editMode: false,
            term_notes: {},
            lease: {} //For header
        };
        this.checkAuthenticated();
        this.GetLease(); //For header
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        //this.ShowAllLeases();
        this.GetContacts();
        //var data = [{ sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 1 },
        //    { sd_num: '20', sd_region: 'Office', sd_building: 'Governors Row', sd_address: '123 test st', sd_city: 'testcity', sd_state: 'IL', sd_sqft: 5108, sd_status: 0 }];
        //this.setState({ contacts: data });
    }


    //For Pageing!
    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.contacts.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    async handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    async handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.contacts.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.contacts.length / pageSize) })
        }
    }

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.contacts;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            valA = valA.toString(); //How do we fix?
            valB = valB.toString(); //How do we fix?
            return valA.localeCompare(valB);
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            contacts: data,
            sort: {
                column,
                direction
            }
        })
    }
    handleSortInt(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.contacts;
        data.sort((a, b) => {
            var valA = a[column] === null ? '' : a[column];
            var valB = b[column] === null ? '' : b[column];
            //return valA.localeCompare(valB);
            if (valA < valB) {
                return -1;
            } else if (valA > valB) {
                return 1;
            } else {
                return 0;
            }
        });
        //data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            contacts: data,
            sort: {
                column,
                direction
            }
        })
    }
    render() {

        // Logic for displaying contacts
        const currentItems = this.state.contacts;

        const renderItems = currentItems.map((candidate, i) => {
            return (
                <>
                    <tr key={i} className={new Date(candidate.rt_start) < new Date() && new Date(candidate.rt_end) > new Date() ? 'highlightRow' : ''} >
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                            {candidate.editMode === false && (
                                <div style={{ 'marginRight': '5px' }}>
                                    {candidate.c_type}
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">Type:</label> <br /> <select
                                        options={this.state.typeOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_type = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        value={candidate.c_type}
                                        style={{ 'width': '220px', 'marginRight': '15px' }}
                                    >
                                        <option key=''></option>
                                        {this.state.typeOptions.map(option => {
                                            return (
                                                <option key={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </td>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                            {candidate.editMode === false && (
                                <div>
                                    {candidate.c_fname} {candidate.c_lname} <br />
                                    {candidate.c_company}<br />
                                    {candidate.c_add1}<br />
                                    {candidate.c_add2 && candidate.c_add2.length > 0 && (<>{candidate.c_add2}<br /></>)}
                                    {candidate.c_city}, {candidate.c_state} {candidate.c_zip} <br />
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">First:</label> <br /> <input
                                        type="text"
                                        value={candidate.c_fname}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_fname = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_fname"
                                        id='c_fname'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Last:</label> <br /> <input
                                        type="text"
                                        value={candidate.c_lname}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_lname = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_lname"
                                        id='c_lname'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Company:</label> <br /> <input
                                        type="text"
                                        value={candidate.c_company}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_company = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_company"
                                        id='c_company'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Add1:</label> <br /> <input
                                        type="text"
                                        value={candidate.c_add1}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_add1 = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_add1"
                                        id='c_add1'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Add2:</label> <br /><input
                                        type="text"
                                        value={candidate.c_add2}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_add2 = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_add2"
                                        id='c_add2'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">City:</label> <br /><input
                                        type="text"
                                        value={candidate.c_city}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_city = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_city"
                                        id='c_city'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">State:</label> <br />
                                    <select
                                        options={this.state.lease.sstateOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_state = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        value={candidate.c_state}
                                        valid={candidate.c_state}
                                        invalid={!candidate.c_state}
                                        style={{ 'width': '50px' }}
                                    >
                                        <option key=''></option>
                                        {this.state.sstateOptions.map(option => {
                                            return (
                                                <option key={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select> <br />
                                    <label className="textLabel editRowLabel">Zip:</label> <br /><input
                                        type="text"
                                        value={candidate.c_zip}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].c_zip = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="c_zip"
                                        id='c_zip'
                                        style={{ 'width': '100px' }}
                                    />
                                </div>
                            )}
                        </td>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                            {candidate.editMode === false && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">Work:</label> <a href={'tel:' + candidate.phone_work} className={(candidate.phone_best === 1 ? 'selectedPhone' : '')}>{candidate.phone_work}</a><br />
                                    <label className="textLabel noTopBottomMargin">Cell:</label> <a href={'tel:' + candidate.phone_cell} className={(candidate.phone_best === 2 ? 'selectedPhone' : '')}>{candidate.phone_cell}</a><br />
                                    <label className="textLabel noTopBottomMargin">Home:</label> <a href={'tel:' + candidate.phone_home} className={(candidate.phone_best === 3 ? 'selectedPhone' : '')}>{candidate.phone_home}</a><br />
                                    <label className="textLabel noTopBottomMargin">Work:</label> <a href={'tel:' + candidate.phone_fax} className={(candidate.phone_best === 4 ? 'selectedPhone' : '')}>{candidate.phone_fax}</a><br />
                                    {/*                                <label className="textLabel">TEMP:</label> {candidate.phone_best}<br />*/}
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">Work:</label> <br /> <input
                                        type="text"
                                        value={candidate.phone_work}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].phone_work = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="phone_work"
                                        id='phone_work'
                                        style={{ 'width': '150px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Cell:</label> <br /> <input
                                        type="text"
                                        value={candidate.phone_cell}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].phone_cell = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="phone_cell"
                                        id='phone_cell'
                                        style={{ 'width': '150px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Home:</label> <br /><input
                                        type="text"
                                        value={candidate.phone_home}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].phone_home = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="phone_home"
                                        id='phone_home'
                                        style={{ 'width': '150px' }}
                                    /> <br />

                                    <label className="textLabel editRowLabel">Fax:</label> <br /><input
                                        type="text"
                                        value={candidate.phone_fax}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].phone_fax = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="phone_fax"
                                        id='phone_fax'
                                        style={{ 'width': '150px' }}
                                    /><br />
                                    <label className="textLabel">Best:</label> <br />
                                    <select
                                        options={this.state.bestOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].phone_best = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        value={candidate.phone_best}
                                        style={{ 'width': '100px' }}
                                    >
                                        <option key=''></option>
                                        {this.state.bestOptions.map(option => {
                                            return (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </td>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noPadding">
                            {candidate.editMode === false && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">Email1:</label> <a href={'mailto:' + candidate.email1} > {candidate.email1}</a><br />
                                    <label className="textLabel noTopBottomMargin">Email2:</label> <a href={'mailto:' + candidate.email2} > {candidate.email2}</a><br />
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <div>
                                    <label className="textLabel firstEditRowLabel">Email1:</label> <br /> <input
                                        type="text"
                                        value={candidate.email1}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].email1 = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="email1"
                                        id='email1'
                                        style={{ 'width': '300px' }}
                                    /> <br />
                                    <label className="textLabel editRowLabel">Email2:</label> <br /> <input
                                        type="text"
                                        value={candidate.email2}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].email2 = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="email2"
                                        id='email2'
                                        style={{ 'width': '300px' }}
                                    />
                                </div>
                            )}
                        </td>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noRightPadding">
                            {candidate.editMode === false && (
                                <div>

                                    <Button
                                        color='primary'
                                        onClick={() => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].prevTerms = Object.assign({}, contactsTemp[i]);
                                            contactsTemp[i].editMode = true;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        className="g-orange-bg g-orange-c g-orange-button gButton"
                                        style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                        disabled={this.state.loading === true ? true : false}
                                        hidden={!this.state.isAdmin ? true : false}
                                    >
                                        Edit
                                    </Button>
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var contactsTemp = this.state.contacts;
                                        if (this.IsEmpty(candidate) === true) {
                                            this.DeleteEmpty(i);
                                        }
                                        else {
                                            contactsTemp[i].editMode = false;
                                            this.setState({ contacts: contactsTemp });
                                            this.SaveContacts(candidate, i);
                                        }

                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    {this.IsEmpty(candidate) === false ? 'Save' : 'Delete'}
                                </Button>
                            )}
                            {candidate.editMode === true && candidate.file_id !== 0 && (
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        var contactsTemp = this.state.contacts;
                                        contactsTemp[i] = contactsTemp[i].prevTerms;
                                        contactsTemp[i].prevTerms = {};
                                        contactsTemp[i].editMode = false;
                                        this.setState({ contacts: contactsTemp });

                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Cancel
                                </Button>
                            )}
                            {candidate.editMode === true && candidate.file_id !== 0 && (
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        this.DeleteExisting(candidate, i);
                                    }}
                                    className="g-orange-bg g-orange-c g-orange-button gButton"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                    disabled={this.state.loading === true ? true : false}
                                    hidden={!this.state.isAdmin ? true : false}
                                >
                                    Delete
                                </Button>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ backgroundColor: '#DDDDDD', color: '#000000' }} className="noBorderColor noPadding" colSpan="5">
                            {candidate.editMode === false && (
                                <div>
                                    <label className="textLabel">Notes:</label> {candidate.notes}<br />
                                </div>
                            )}
                            {candidate.editMode === true && (
                                <div>
                                    <label className="textLabel">Notes:</label> <br /> <textarea
                                        type="textarea"
                                        value={candidate.notes}
                                        onChange={(e) => {
                                            var contactsTemp = this.state.contacts;
                                            contactsTemp[i].notes = e.target.value;
                                            this.setState({ contacts: contactsTemp });
                                        }}
                                        name="notes"
                                        id='notes'
                                        style={{ 'width': '100%' }}
                                    />
                                </div>
                            )}
                        </td>
                    </tr>
                </>
            )
        });

        return (
            <div className="pageDiv noMaxWidth">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>
                             
                        </Col>
                        <Col>
                             
                        </Col>
                        <Col>
                             
                        </Col>
                        <Col>
                             
                        </Col>
                        <Col>
                             
                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Summary?id=' + this.state.leaseId}
                            >
                                Summary
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-RentTerms?id=' + this.state.leaseId}
                            >
                                Rent Terms
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-CriticalDates?id=' + this.state.leaseId}
                            >
                                Critical Dates
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Notes?id=' + this.state.leaseId}
                            >
                                Notes
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Documents?id=' + this.state.leaseId}
                            >
                                Documents
                            </NavLink>
                        </Col>
                        <Col className="g-orange-bg g-orange-c">
                                Contacts
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing noBottomBorder">
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '100px' }}>
                                            Type
                                            <FaSort
                                                color={this.state.sort.column === 'c_type' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSortInt('c_type')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Company
                                            <FaSort
                                                color={this.state.sort.column === 'c_company' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('c_company')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '200px' }}>
                                            Phone Numbers
                                            <FaSort
                                                color={this.state.sort.column === 'phone_work' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('phone_work')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c" style={{ 'minWidth': '106px' }}>
                                            Email
                                            <FaSort
                                                color={this.state.sort.column === 'email1' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('email1')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th className="g-warm-gray-bg g-warm-gray-c buttonColumn" style={{ 'width': '106px' }}>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                    <tr>
                                                        <td className="noSidePadding"></td>
                                                            <td className="noSidePadding"></td>
                                                            <td className="noSidePadding"></td>
                                                            <td className="noSidePadding"></td>
                                                            <td className="rightAlignButtons noRightPadding">
                                                            <Button
                                                                color='primary'
                                                                onClick={() => {
                                                                    this.AddRows(1);
                                                                }}
                                                                className="g-orange-bg g-orange-c g-orange-button gButton"
                                                                style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", marginLeft: '10px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                    hidden={!this.state.isAdmin ? true : false}
                                                            >
                                                                Add
                                                                </Button>
                                                                <Link
                                                                    to="/Lease/ActiveLeases?search=1"
                                                                    color='primary'
                                                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary"
                                                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px' }}
                                                                    disabled={this.state.loading === true ? true : false}
                                                                >
                                                                    Back To List
                                                                </Link>
                                                        </td>
                                                    </tr>

                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    async GetContacts() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetContacts?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        })
        const data = await response.json();
        this.setState({ contacts: data });
    }
    AddRows(number) {
        for (var i = 0; i < number; i++) {
            var newRow = { file_id: 0, c_site: this.state.leaseId, type: null, filename: '', name: '', text: '', date: null, user_id: 0, active: true, editMode: true };
            var contactsTemp = this.state.contacts;
            contactsTemp.push(newRow);
            this.setState({ contacts: contactsTemp });
        }
    }
    IsEmpty(candidate) {
        if (candidate.c_type || candidate.c_user || candidate.c_type || candidate.c_fname || candidate.c_lname || candidate.c_company || candidate.c_add1 || candidate.c_add2 || candidate.c_city || candidate.c_state || candidate.c_zip || candidate.phone_work || candidate.phone_cell || candidate.phone_home || candidate.phone_best || candidate.phone_fax || candidate.email1 || candidate.email2 || candidate.notes) {
            //If anything is filled out, it's not empty.
            return false;
        }
        if (candidate.c_id) {
            //If it's not a new item, it's not considered empty for this.
            return false;
        }
        return true;
    }
    async SaveContacts(documentFile, index) {
        if (this.IsValid()) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/EditContacts', {
                method: 'POST',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(documentFile)
            });

            const data = await response.json();

            if (data) {
                if (data.c_id > 0) {
                    var contactsTemp = this.state.contacts;
                    contactsTemp[index].c_id = data.c_id;
                    this.setState({ contacts: contactsTemp });
                }
            }
        }        
    }

    DeleteEmpty(index) {
        var contactsTemp = this.state.contacts;
        contactsTemp.splice(index, 1);
        this.setState({ contacts: contactsTemp });
    }

    async DeleteExisting(candidate, index) {
        if (window.confirm("Are you sure you want to delete this Contact?") === true) {
            const token = Session.getToken();
            const response = await fetch('api/Leases/DeleteContacts?id=' + candidate.c_id, {
                method: 'GET',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            })

            var contactsTemp = this.state.contacts;
            contactsTemp.splice(index, 1);
            this.setState({ contacts: contactsTemp });
        }
    }

    async SaveAll(candidate, index) {
        var contactsTemp = this.state.contacts;
        for (let i = 0; i < contactsTemp.length; i++) {

        }
    }

    //For header
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        this.setState({ lease: data });
    }

    IsValid(contact) {
        //if (!contact) {
        //    alert("Contact can't be blank.");
        //    return false;
        //}
        //if (!contact.c_type) {
        //    alert("Contact type is required.");
        //    return false;
        //}
        return true;
    }
}

